import { render, staticRenderFns } from "./flowDetailRVT.vue?vue&type=template&id=6f071312&scoped=true"
import script from "./flowDetailRVT.vue?vue&type=script&lang=js"
export * from "./flowDetailRVT.vue?vue&type=script&lang=js"
import style0 from "./flowDetailRVT.vue?vue&type=style&index=0&id=6f071312&prod&lang=scss&scoped=true"
import style1 from "./flowDetail.scss?vue&type=style&index=1&id=6f071312&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f071312",
  null
  
)

export default component.exports